import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import withTheme from "../../../libs/themr/withTheme";
import styles from "./TabsContent.module.scss";

const TabsContent = ({ theme, children, visible }) => {
  return <div className={cx(theme.content, { [theme.notVisible]: !visible })}>{children}</div>;
};

TabsContent.propTypes = {
  theme: PropTypes.object.isRequired,
  children: PropTypes.node,
  visible: PropTypes.bool
};

TabsContent.defaultProps = {
  children: null,
  visible: true
};

export default withTheme(styles)(React.memo(TabsContent));
